import Vue from 'vue'
import VueFirestore from 'vue-firestore'
import firebase from 'firebase'
import App from './App'
import router from './router'
import Sortable from 'sortablejs'

require('firebase/firestore')

Vue.use(VueFirestore)

Vue.directive('sortable', {
  inserted: function (el, binding) {
    new Sortable(el, binding.value || {})
  }
})

// export const config = {
//   apiKey: "AIzaSyBYCfEoVu6WrI83STKt7ACfJvffIWycANw",
//   authDomain: "static-site-test-a5cf9.firebaseapp.com",
//   databaseURL: "https://static-site-test-a5cf9.firebaseio.com",
//   projectId: "static-site-test-a5cf9",
//   storageBucket: "static-site-test-a5cf9.appspot.com",
//   messagingSenderId: "247695522383"
// }
export const config = {
  apiKey: "AIzaSyDVzQ7DUIjs8r-OQYwRYxLwFJ3nf87LxZw",
  authDomain: "archetype-parallax.firebaseapp.com",
  databaseURL: "https://archetype-parallax.firebaseio.com",
  projectId: "archetype-parallax",
  storageBucket: "archetype-parallax.appspot.com",
  messagingSenderId: "365021782852"
}

export const firebaseApp = firebase.initializeApp(config)
export const firestore = firebaseApp.firestore();

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  firestore() {
    return {
      pages: firestore.collection('pages'),
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js